import React, { Component } from "react";
import {
    Row, Col
} from "reactstrap";


import Registry from "../../../../Utils/Registry";
import Helpers from "../../../../Utils/Helpers";
import {NotificationManager} from "react-notifications";

import ExportFormFormat from "../Forms/Format";
import ExportFormColumns from "../Forms/Columns";
import ExportFormType from "../Forms/Type";
import ExportFormUniq from "../Forms/Uniq";
import ExportFormRecurrent from "../Forms/Rec";
import { ExportConfirmationModal } from "../Modal/Confirmation";


export default class ExportOrderForm extends Component{
    static defaultProps = {
        onCreateRec: () => {}
    };

    constructor(props){
        super(props);

        this.headers = {
            shorten: "Numero commande",
            location: "Adresse",
            paid: "Est payée",
            created_at: "Date de creation de la commande",
            start_datetime: "Date de demande",
            ending_datetime: "Date de livraison",
            invoice_id: "Facture",
            description: "Véhicule",
            plate: "Plaque d'immatriculation",
            color: "Couleur vehicule",
            quantity_delivered: "Quantité delivrée",
            km: "Relevé kilometrique (en option)",
            gas_name: "Carburant",
            gas_price: "Prix unitaire",
            line_fees: "Frais de service par véhicules",
        };

        this.state = {
            keys: Object.keys(this.headers),
            loading: false,
            exportType: 'unique',
            noColumnError: false,
            sentTo: [],
            showConfirmation: false,
            format: "excel"
        };

        this.api = Registry.registered("api");
    }

    exportOneTime = (dateMin, dateMax, sentTo, title) => {
        if(!this.state.keys.length){
            this.setState({noColumnError: true});
            return;
        }
        else 
            this.setState({loading: true, noColumnError: false});
        
        let date_filter = "";
        if(dateMin){
            date_filter = "&dates="+dateMin;
            if(dateMax)
                date_filter += "," + dateMax;
        }

        const { format, keys } = this.state;
        
        const export_url = `/orders/export?v=${Helpers.uniqId()}&format=${format}&is_business=1&name=${title}&send_to=${sentTo.join(",")}&keys=${keys.join(",")}${date_filter}`;

        this.api.get(export_url)
            .then(() => this.setState({loading: false, showConfirmation: true, sentTo: sentTo}))
            .catch(_ => {
                this.setState({loading: false});
                NotificationManager.error("Une erreur est survenue, impossible d'exporter les données");
            });
    };

    createRecExport = data => {            
        let user = Registry.registered("user");
        const { onCreateRec } = this.props;

        if(user){      
            if(!this.state.keys.length){
                this.setState({noColumnError: true});
                return;
            }
            else 
                this.setState({loading: true, noColumnError: false});

            this.api.post(`/business/${user.business_id}/recurrent_export`, {
                ...data,
                keys: this.state.keys.join(","),
                type: "orders",
                format: this.state.format
            })
                .then(_ => {
                    this.setState({loading: false});
                    NotificationManager.success("Export recurrent créé");
                    onCreateRec && onCreateRec();
                })
                .catch(_ => {
                    NotificationManager.error("impossible de créer l'export recurrent");
                    this.setState({loading: false});
                });
        }
        else
            NotificationManager.error("Impossible de faire la demande");
    };

    render(){
        const { exportType, keys, loading, noColumnError, showConfirmation, sentTo } = this.state;

        return (
            <div>
                {/* <div className="d-flex justify-content-between pad-b-10">
                    <h2 className="ty-subtitle">
                        Export des commandes
                    </h2>
                </div> */ }

                <ExportConfirmationModal shown={showConfirmation} sentTo={sentTo} onCloseRequest={_ => this.setState({showConfirmation: false})} />

                <div className="ty-block">
                    <Row>
                        <Col md={6}>
                            { noColumnError && <p className="red">Vous devez choisir au moins une colonne &agrave; exporter</p> }
                            <ExportFormColumns 
                                columns={this.headers} 
                                defaultSelected={keys}
                                onListChange={list => {this.setState({keys: list});}} 
                            />
                        </Col>
                        <Col md={6} className="relative">
                            <ExportFormType 
                                onExportTypeChanged={type => {this.setState({exportType: type});}} 
                            />

                            <br />
    
                            <ExportFormFormat 
                                onExportFormatChanged={eFormat => {this.setState({format: eFormat});}} 
                            />
                            
                            <br />

                            {
                                exportType === 'unique' ?
                                    <ExportFormUniq loading={loading} onSubmit={this.exportOneTime} />
                                    :
                                    <ExportFormRecurrent onSubmit={this.createRecExport} />
                            }
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Operations/Export/Order/Form.js